import i18n from '@/i18n'
import moment from 'moment'
import { setupCalendar } from 'v-calendar'
import { getFirstDayOfWeek } from '@/lib/date'
import { make } from 'vuex-pathify'

// This key must be identical to V1 (angular.js) key.
const localStorageCurrentLocaleKey = 'NG_TRANSLATE_LANG_KEY'

// Please, when necessary, add new locales here.
const availableLocales = {
    'en-US': 'English (US)',
    'es-ES': 'Español (ES)',
    'pt-BR': 'Português (BR)',
}

const isLocaleValid = (locale) => {
    const validLocales = Object.keys(availableLocales)
    return validLocales.includes(locale)
}

const setPluginsLocaleConfiguration = (locale) => {
    /*
     * Please, when necessary, add locale setting of other plugins here.
     */

    // i18n
    i18n.locale = locale

    // moment
    moment.locale(locale)

    // v-calender
    setupCalendar({
        locale: locale,
        firstDayOfWeek: getFirstDayOfWeek(locale),
    })
}

const setLastLocale = (locale) => {
    window.localStorage.setItem(localStorageCurrentLocaleKey, locale)
}
const getLastLocale = () => window.localStorage.getItem(localStorageCurrentLocaleKey)
const getDefaultLocale = () => process.env.VUE_APP_I18N_LOCALE
const getFallbackLocale = () => process.env.VUE_APP_I18N_FALLBACK_LOCALE

const state = {
    currentLocale: null,
}

const mutations = {
    ...make.mutations(state),
    SET_CURRENT_LOCALE: (state, locale) => {
        state.currentLocale = locale
        setPluginsLocaleConfiguration(locale)
        setLastLocale(locale)
    },
}

const actions = {
    ...make.actions('items'),
    setSystemDefaultLocale({ commit }) {
        if (isLocaleValid(getLastLocale())) {
            commit('SET_CURRENT_LOCALE', getLastLocale())
        } else {
            commit('SET_CURRENT_LOCALE', getDefaultLocale() || getFallbackLocale())
        }
    },
    setSystemCurrentLocale({ commit }, locale) {
        if (!isLocaleValid(locale)) throw new Error('Invalid locale.')
        commit('SET_CURRENT_LOCALE', locale)
    },
}

const getters = {
    ...make.getters(state),
    locales() {
        return availableLocales
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
